import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import "./FrequentlyBought.css";

function FrequentlyBought() {
  const items = [
    {
      id: 1,
      title: "Interview Preparation",
      description: "Tailored interview prep for your role.",
      price: "₹499",
      illustration: (
        <svg viewBox="0 0 200 120" width="100%" height="100%">
          <rect width="200" height="120" rx="8" fill="#f3edf7" />
          {/* Conceptual people interviewing silhouette graphics */}
          <circle cx="65" cy="50" r="12" fill="#2d3748" />
          <path d="M45,85 C45,70 55,65 65,65 C75,65 85,70 85,85" fill="#df147a" />
          <circle cx="135" cy="50" r="12" fill="#2d3748" />
          <path d="M115,85 C115,70 125,65 135,65 C145,65 155,70 155,85" fill="#6f42c1" />
          <line x1="85" y1="50" x2="115" y2="50" stroke="#a0aec0" strokeWidth="2" strokeDasharray="4" />
        </svg>
      )
    },
    {
      id: 2,
      title: "LinkedIn Makeover",
      description: "Revamp your LinkedIn for better engagement.",
      price: "₹1,999",
      illustration: (
        <svg viewBox="0 0 200 120" width="100%" height="100%">
          <rect width="200" height="120" rx="8" fill="#f3edf7" />
          {/* Conceptual phone profile layout graphics */}
          <rect x="70" y="20" width="60" height="80" rx="6" fill="#ffffff" stroke="#cbd5e1" strokeWidth="2" />
          <circle cx="100" cy="45" r="10" fill="#df147a" />
          <rect x="80" y="65" width="40" height="4" rx="2" fill="#6f42c1" />
          <rect x="85" y="75" width="30" height="4" rx="2" fill="#cbd5e1" />
        </svg>
      )
    }
  ];

  return (
    <div className="frequently-bought-section">
      <h3 className="section-title">Frequently bought together</h3>
      
      <div className="outer-grey-container">
        <Row className="g-4">
          {items.map((item) => (
            <Col md={6} key={item.id}>
              <div className="addon-product-card">
                {/* Product Image Wrapper */}
                <div className="image-frame-holder">
                  {item.illustration}
                </div>
                
                {/* Content Block */}
                <div className="card-details-panel">
                  <h4 className="product-heading">{item.title}</h4>
                  <p className="product-summary">{item.description}</p>
                  
                  <div className="pricing-buy-row">
                    <div className="price-label-group">
                      <span className="starting-text">Starting @</span>
                      <span className="price-amount">{item.price}</span>
                    </div>
                    <Button className="action-buy-btn">
                      Buy Now
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}

export default FrequentlyBought;